import { FaArrowRight } from 'react-icons/fa';
export default FaArrowRight;

//# sourceMappingURL=ArrowRight.js.map